import { useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Form,
  Input,
  Card,
  Select,
  Button,
  Spin,
} from "antd";
import useAxiosPost from "../../hooks/useAxiosPost";
import { useNavigate, useParams } from "react-router-dom";
import useMultiNotification from "../../hooks/useNotification";
import {
  setUserAuthTokenInSessionStorage,
  setUserTypeInSessionStorage,
} from "../../helpers/userDetails";
const LoginAsCompanyCEO = () => {
  const navigate = useNavigate();

  const { openNotification, contextHolder } = useMultiNotification();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<SuperAdminCompanyLogin>("companies/loginAsAdmin");
  const { intPkCompanyID } = useParams();
  useEffect(() => {
    if (apiResponse !== null) {
      const responseData: any = apiResponse.responseData;
      const { auth_token, role } = responseData;
      console.log({ responseData });
      setUserTypeInSessionStorage(role || "");
      setUserAuthTokenInSessionStorage(auth_token || "");
      window.location.href = "/";
    }
  }, [apiResponse]);
  useEffect(() => {
    postApiData({ intPkCompanyID: Number(intPkCompanyID) });
  }, []);

  return (
    <>
      {contextHolder}

      <Row style={{ width: "100%" }}>
        <Col span={24}>
          <Spin size="large" />
        </Col>
      </Row>
    </>
  );
};
export default LoginAsCompanyCEO;
